import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BackOfficeReceiptTransformer  {
    _originalTypeClassName = "zERP.BO.BackOfficeReceiptTransformer";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BackOfficeReceiptTransformer.translate = translateService;
}
this.BackOfficeReceiptTransformerKey = null;
this._key = this.BackOfficeReceiptTransformerKey = 0; 
}

static translate: TranslateService;
_key: any;
private _BackOfficeReceiptTransformerKey:any;
get BackOfficeReceiptTransformerKey(): any {
    return this._BackOfficeReceiptTransformerKey;
  }
set BackOfficeReceiptTransformerKey(value: any) {
    this._BackOfficeReceiptTransformerKey = value;
    this._key = value;
  }

static GetGroupKey(document: any,config: any,execution: any): any{return document.receiptSeries + "_" + document.receiptNo + "_" + Joove.Common.safeNumber(document.installmentOrder);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BackOfficeReceiptTransformerKey == null || $this.BackOfficeReceiptTransformerKey == 0;
            }


}